import type { ErrorRegistryShape } from '../common/common.error';

export const FUND_ERROR = {
  NOT_FOUND_FUND: { status: 404, message: 'Fund not found' },
  /** D3 투자 · 회수 리포트 등 업무 자료가 있는 펀드는 지울 수 없다 */
  CONFLICT_FUND_IN_USE: { status: 409, message: 'Fund has related records' },
  /**
   * 검사와 저장 사이에 다른 요청이 이 펀드를 바꿨다 — 수정하려던 목적 · LP 출자 · 납입 · 분배 행이 이미 지워졌거나,
   * 지우려던 목적을 D3 투자가 새로 쓰기 시작했다. 다시 불러와 다시 저장한다
   */
  CONFLICT_FUND_CHANGED: { status: 409, message: 'Fund was changed by another request' },
} as const satisfies ErrorRegistryShape;
